import { render, staticRenderFns } from "./ComoAnadirProductos.vue?vue&type=template&id=24bc8ed0&scoped=true"
import script from "./ComoAnadirProductos.vue?vue&type=script&lang=js"
export * from "./ComoAnadirProductos.vue?vue&type=script&lang=js"
import style0 from "./ComoAnadirProductos.vue?vue&type=style&index=0&id=24bc8ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc8ed0",
  null
  
)

export default component.exports